/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from 'react';
import {FaThLarge} from 'react-icons/fa';
import * as RiIcons from 'react-icons/ri';
import {MdSensors} from "react-icons/md"
import sidebar_ObjDef from "../../images/landing_images/objects_white.png";
import styled from 'styled-components';
import sidebar_SesOBJ from "../../images/landing_images/Vehicle_SensingSystem_whiteLogo.png";
import RadarIcon from '@mui/icons-material/Radar';
import VideocamIcon from '@mui/icons-material/Videocam';
import LooksIcon from '@mui/icons-material/Looks';
import RealWorldObjectsIcon from '@mui/icons-material/Category';
import PotentiallyMovingObjectsIcon from '@mui/icons-material/DirectionsCar';
import SignsIcon from '@mui/icons-material/Warning';
import MiscellaneousObjectsIcon from '@mui/icons-material/Category'
import {
  coverageRequirementsLandingRoute,
  coverageRequirementsSidebarTitle
} from '../../pages/CoverageRequirements/constants';
import ADAS_PROGRAMS_CONSTANTS from "../../pages/AdasPrograms/constants";
import VAR_COMMON_CONSTANTS from "../../../constants/globalVariables";

import { ReactComponent as UltrasonicSvg } from '../../images/sensors/ultrasonic1.svg';
import { ReactComponent as LidarSvg } from '../../images/sensors/lidar4.svg';
import {SCENARIO_ANALYSIS_CONSTANTS} from '../../pages/ScenarioAnalysis/constants';
import { SENSING_SYSTEM_ARCHITECTURE_DESIGN_CONSTANTS } from '../../pages/SensingSystemArchitectureDesign/constants';


const MenuItemImage = styled.img`
    padding : 5px;
    height: 60px;
    width: 45px;
    margin-left: -6px;
`;


export const SidebarData = [
  {
    title: 'Dashboard',
    path: '/landing',
    icon: <FaThLarge style={{
      height: "50px",
      width: "30px",
    }}/>,
    iconClosed: <RiIcons.RiArrowDownSFill/>,
    iconOpened: <RiIcons.RiArrowUpSFill/>,
  },
  {
    title: 'Real World Objects',
    icon: <RealWorldObjectsIcon style={{height: "50px", width: "30px"}}/>,
    iconClosed: <RiIcons.RiArrowDownSFill/>,
    iconOpened: <RiIcons.RiArrowUpSFill/>,
    subNav: [
      {
        title: 'Potentially Moving Objects',
        path: '/potentiallymovingobjects',
        cName: 'sub-nav',
        icon: <PotentiallyMovingObjectsIcon style={{
          height: "50px",
          width: "30px",
        }}/>,
      },
      {
        title: 'Sign Objects',
        path: '/signs',
        cName: 'sub-nav',
        icon: <SignsIcon style={{
          height: "50px",
          width: "30px",
        }}/>,
      },
      {
        title: 'Miscellaneous Objects',
        path: '/miscellaneousObjects',
        cName: 'sub-nav',
        icon: <MiscellaneousObjectsIcon style={{
          height: "50px",
          width: "30px",
        }}/>,
      }
    ]
  },
  {
    title: 'Object Definitions', 
    path: '/objects',
    icon: <MenuItemImage src={sidebar_ObjDef}/>,
  },
  {
    title: 'Sensor Database',
    icon: <MdSensors style={{
      height: "50px",
      width: "30px",
    }}/>,
    iconClosed: <RiIcons.RiArrowDownSFill/>,
    iconOpened: <RiIcons.RiArrowUpSFill/>,

    subNav: [
      {
        title: 'Radars',
        path: '/sensorradar',
        cName: 'sub-nav',
        icon: <RadarIcon style={{
          height: "50px",
          width: "30px",
        }}/>,
      },
      {
        title: 'Cameras',
        path: '/sensorcamera',
        cName: 'sub-nav',
        icon: <VideocamIcon style={{
          height: "50px",
          width: "30px",
        }}/>
      },
      {
        title: `${VAR_COMMON_CONSTANTS.LIDAR}s`,
        path: '/sensorlidar',
        cName: 'sub-nav',
        icon: <LidarSvg style={{
          height: "50px",
          width: "30px",
        }}/>
      },
      {
        title: `${VAR_COMMON_CONSTANTS.ULTRASONIC}s`,
        path: '/sensorultrasonic',
        cName: 'sub-nav',
        icon: <UltrasonicSvg style={{
          height: "50px",
          width: "30px",
        }}/>
      },
    ]
  },
  {
    title: coverageRequirementsSidebarTitle,
    path: coverageRequirementsLandingRoute,
    icon: <LooksIcon style={{
      width: "30px",
      height: "50px",
    }}/>
  },
  {
    title: ADAS_PROGRAMS_CONSTANTS.sidebar.title,
    path: ADAS_PROGRAMS_CONSTANTS.mainRoute,
    icon: ADAS_PROGRAMS_CONSTANTS.sidebar.icon
  },
  {
    title: SENSING_SYSTEM_ARCHITECTURE_DESIGN_CONSTANTS.app.title,
    path: SENSING_SYSTEM_ARCHITECTURE_DESIGN_CONSTANTS.landing.route,
    icon: SENSING_SYSTEM_ARCHITECTURE_DESIGN_CONSTANTS.app.icon,
  },
  {
    title: 'Vehicle Programs',
    path: '/vehicleprogram',
    icon: <MenuItemImage src={sidebar_SesOBJ}/>
  },
  {
    title: SCENARIO_ANALYSIS_CONSTANTS.app.title,
    path: SCENARIO_ANALYSIS_CONSTANTS.landing.route,
    icon: SCENARIO_ANALYSIS_CONSTANTS.app.icon,
  },
];
